import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { appAgentService } from '../../../services/central-api/app-agent';
import { StyleProp, TextStyle } from 'react-native';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number;
    setValue: React.Dispatch<SetStateCallback<number>>;
    zIndex: number;
    disabled?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

function ScheduleDropdown({ value, setValue, zIndex, disabled = false, labelStyle, viewStyle }: Props) {
    const [selectableItems, setSelectableItems] = useState<{ label: string; value: number; }[]>([]);

    async function getItems() {
        try {
            const schedules = await appAgentService.getAgentSchedules();
            setSelectableItems([
                ...schedules.map((item) => {
                    return {
                        value: item.id || 0,
                        label: item.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    return (
        <FilterDropdown
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            label={translate('schedule')}
            items={selectableItems}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
        />
    );
}

export default ScheduleDropdown;
